"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortPoliciesByStartDate = exports.buildCancellationPolicies = void 0;
var formatDate_1 = require("./formatDate");
var date_1 = require("./date");
var sortPoliciesByStartDate = function (a, b) {
    if (a.start < b.start) {
        return -1;
    }
    if (a.start > b.start) {
        return 1;
    }
    return 0;
};
exports.sortPoliciesByStartDate = sortPoliciesByStartDate;
var buildCancellationPolicies = function (policies, options) {
    var policyDescriptions = [];
    if (!(policies === null || policies === void 0 ? void 0 : policies.length)) {
        return {
            policies: [],
            description: [
                'If you cancel your booking, you are not eligible for a refund or credit for a future stay.',
            ],
        };
    }
    var policiesIntTimezone = policies.map(function (policy) {
        var start = new Date(policy.start);
        if ((policy === null || policy === void 0 ? void 0 : policy.nights) === 0) {
            start = date_1.subDays(new Date(policy.end), 1);
        }
        return __assign(__assign({}, policy), { timezone: options.timezone, start: start, end: new Date(policy.end) });
    });
    policiesIntTimezone.sort(sortPoliciesByStartDate);
    for (var _i = 0, policiesIntTimezone_1 = policiesIntTimezone; _i < policiesIntTimezone_1.length; _i++) {
        var policy = policiesIntTimezone_1[_i];
        var dateFormat = formatDate_1.formattedDateByTimezone(policy.start.toISOString(), options.timezone);
        if (!policyDescriptions.length) {
            policyDescriptions.push("Free cancellation until " + dateFormat + " (local time of property).");
        }
        if (policy === null || policy === void 0 ? void 0 : policy.nights) {
            policyDescriptions.push("Cancellations made after " + dateFormat + " (local time of property) are subject to a " + policy.nights + " " + (policy.nights > 1 ? 'nights' : 'night') + " penalty plus taxes and fees.");
        }
        if (policy === null || policy === void 0 ? void 0 : policy.percent) {
            policyDescriptions.push("Cancellations made after " + dateFormat + " (local time of property) will result in a " + policy.percent + "% penalty of the stay charges and fees.");
        }
        if (policy === null || policy === void 0 ? void 0 : policy.amount) {
            policyDescriptions.push("Cancellations made after " + dateFormat + " (local time of property) will result in a " + policy.amount + " " + policy.currency + " fee.");
        }
    }
    policyDescriptions.push('If you fail to check-in for this reservation, or if you cancel or change this reservation after check-in, you may incur penalty charges at the discretion of the property of up to 100% of the booking value.');
    return {
        policies: policiesIntTimezone,
        description: policyDescriptions,
    };
};
exports.buildCancellationPolicies = buildCancellationPolicies;
